import type { Ref } from 'vue'

import { sellerProfileAPI } from '@backmarket/http-api'
import type {
  GetLegalDocumentsItem,
  LegalDocumentType,
} from '@backmarket/http-api/src/api-specs-seller-backoffice/seller-profile'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { uploadFile } from '@backmarket/nuxt-module-http/uploadFile'

import { ROUTE_NAMES } from '~/constants/routes'

export function getHomeLink(hasCompletedOnboarding: boolean) {
  return hasCompletedOnboarding
    ? ROUTE_NAMES.PROFILE.HOME
    : ROUTE_NAMES.ONBOARDING.PROFILE.HOME
}

export function getCompanyInfoLink(hasCompletedOnboarding: boolean) {
  return hasCompletedOnboarding
    ? ROUTE_NAMES.PROFILE.COMPANY_INFO
    : ROUTE_NAMES.ONBOARDING.PROFILE.COMPANY_INFO
}

export function getLegalDetailsLink(hasCompletedOnboarding: boolean) {
  return hasCompletedOnboarding
    ? ROUTE_NAMES.PROFILE.LEGAL_DETAILS
    : ROUTE_NAMES.ONBOARDING.PROFILE.LEGAL_DETAILS
}

export function getContactDetailsLink(hasCompletedOnboarding: boolean) {
  return hasCompletedOnboarding
    ? ROUTE_NAMES.PROFILE.CONTACT_DETAILS
    : ROUTE_NAMES.ONBOARDING.PROFILE.CONTACT_DETAILS
}

export function getUserPermissionsLink(hasCompletedOnboarding: boolean) {
  return hasCompletedOnboarding
    ? ROUTE_NAMES.PROFILE.USER_PERMISSIONS
    : ROUTE_NAMES.ONBOARDING.PROFILE.USER_PERMISSIONS
}

export async function uploadLegalDocument(
  sellerId: number,
  file: File,
  type: LegalDocumentType,
  cancelPoll: Ref<(() => void) | undefined>,
) {
  const { status, handle: urlHandle } = await uploadFile(
    'onboarding_merchant_document',
    { sellerId },
    file,
    cancelPoll,
  )
  if (status === 'success') {
    return $httpFetch(sellerProfileAPI.postLegalDocument, {
      body: { urlHandle, type },
    })
  }

  return null
}

export async function deleteLegalDocument(id: GetLegalDocumentsItem['id']) {
  return $httpFetch(sellerProfileAPI.deleteLegalDocument, {
    body: { id },
  })
}
